import script from "./duty.vue?vue&type=script&setup=true&lang=js"
export * from "./duty.vue?vue&type=script&setup=true&lang=js"

import "./duty.vue?vue&type=style&index=0&id=418b26ba&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-418b26ba"]])

export default __exports__